// extracted by mini-css-extract-plugin
export default {"wrapper":"button-radius-5_wrapper__WbLTC"};